function toCleanString(value) {
  return String(value || "").trim();
}

function initialsFromParts(firstName, lastName, fallback) {
  const first = toCleanString(firstName);
  const last = toCleanString(lastName);
  const firstInitial = first ? first[0].toUpperCase() : "";
  const lastInitial = last ? last[0].toUpperCase() : "";
  const combined = `${firstInitial}${lastInitial}`.trim();
  if (combined) return combined.slice(0, 2);
  return fallback;
}

export function getInitialsFromName(name, fallback = "U") {
  const safeFallback = toCleanString(fallback) || "U";
  const clean = toCleanString(name);
  if (!clean) return safeFallback;

  const parts = clean.split(/\s+/).filter(Boolean);
  if (parts.length === 1) {
    return parts[0][0].toUpperCase();
  }
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

export function getUserInitials(user, fallback = "U") {
  const safeFallback = toCleanString(fallback) || "U";
  if (!user) return safeFallback;

  if (typeof user === "string") {
    return getInitialsFromName(user, safeFallback);
  }

  const firstName = user.first_name ?? user.firstName ?? "";
  const lastName = user.last_name ?? user.lastName ?? "";
  const fromParts = initialsFromParts(firstName, lastName, "");
  if (fromParts) return fromParts;

  const fullName = user.full_name ?? user.fullName ?? user.name ?? "";
  const fromName = getInitialsFromName(fullName, "");
  if (fromName) return fromName;

  const username = toCleanString(user.username);
  if (username) return username[0].toUpperCase();

  return safeFallback;
}
